import {
  Box,
  Flex,
  Text,
  Button,
  Image,
  Textarea,
  Icon,
  Center,
} from '@chakra-ui/react'
import SubTitle from './SubTitle'
import MessageBot from './MessageBot'
import TypingPhrase from './TypingPhrase'
import ArrangementPhrase from './ArrangementPhrase'
import RadioPhrase from './RadioPhrase'
import {useEffect, useRef, useState} from 'react'
import MessageReply from './MessageReply'
import {useDispatch, useSelector} from 'react-redux'
import SpeakingPhrase from './SpeakingPhrase'
import VideoCustom from './VideoCustom'
import {updateIsDisableReply, updateIsOpenSubTitle} from '@redux/revise/revise'
import reviseRequest from '@apis/revise'
import rightAudio from '@assets/audios/right.mp3'
import wrongAudio from '@assets/audios/wrong.mp3'
import useExamRoom from './useExamRoom'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as RotateLeft} from '@assets/svgs/rotate_left.svg'
import IconSend from '@assets/svgs/send.svg'

const Exercise3 = ({
  dataQuestions,
  currentLevelIndex,
  currentQuestionIndex,
  setCurrentLevelIndex,
  setCurrentQuestionIndex,
}: {
  dataQuestions: any
  currentLevelIndex: any
  currentQuestionIndex: any
  setCurrentLevelIndex: any
  setCurrentQuestionIndex: any
}) => {
  const {currentQuestion, isDisableReply} = useSelector(
    (state: any) => state.revise,
  )
  const [dataMessages, setDataMessages] = useState<any>([])
  const [dataReply, setDataReply] = useState<any>()
  const [isShowReplyBox, setIsShowReplyBox] = useState<any>(true)
  const [isResult, setIsResult] = useState<any>()
  const [isLoading, setIsLoading] = useState<any>(false)
  const dispatch = useDispatch()
  const {handlePlayAudio, handlePauseAudio} = useExamRoom()
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const [isShowInput, setIsShowInput] = useState<any>(false)

  useEffect(() => {
    if (!currentQuestion) return
    const firstMsg = {
      type: 'bot',
      msg: currentQuestion?.data?.question?.question,
    }
    setDataMessages([firstMsg])
  }, [currentQuestion])

  const getDescriptionQuestion = () => {
    if (currentQuestion.type === 'LV2_LISTEN_AND_FILL_THE_BLANK') {
      return 'Nghe và điền cụm vào chỗ trống'
    }
    if (currentQuestion.type === 'LV2_LISTEN_AND_CHOOSE_PHRASE') {
      return 'Nghe và chọn cụm thích hợp'
    }
    if (currentQuestion.type === 'LV3_LISTEN_AND_ANSWER_BY_SPEAKING') {
      return 'Nghe và trả lời câu hỏi'
    }
    if (currentQuestion.type === 'LV3_LISTEN_AND_ANSWER_BY_TYPING') {
      return 'Nghe và viết cụm thích hợp'
    }
  }

  const getReplyBox = () => {
    switch (currentQuestion.type) {
      case 'LV2_LISTEN_AND_FILL_THE_BLANK':
        // Message sắp xếp từ
        return (
          <ArrangementPhrase
            setDataReply={setDataReply}
            setIsResult={setIsResult}
          />
        )
      case 'LV2_LISTEN_AND_CHOOSE_PHRASE':
        // Message radio chọn từ, cụm từ
        return (
          <RadioPhrase setDataReply={setDataReply} setIsResult={setIsResult} />
        )
      case 'LV3_LISTEN_AND_ANSWER_BY_SPEAKING':
        return (
          <SpeakingPhrase
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            dataReply={dataReply}
            setDataReply={setDataReply}
            isShowInput={isShowInput}
            setIsShowInput={setIsShowInput}
          />
        )
      case 'LV3_LISTEN_AND_ANSWER_BY_TYPING':
        // Message nhập cum còn thiếu
        return (
          <TypingPhrase
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setDataReply={setDataReply}
            setIsResult={setIsResult}
            setIsShowReplyBox={setIsShowReplyBox}
            setDataMessages={setDataMessages}
          />
        )
      default:
        break
    }
  }

  const handleTestReply = async () => {
    handlePauseAudio()
    if (isShowReplyBox) {
      if (currentQuestion.type === 'LV3_LISTEN_AND_ANSWER_BY_SPEAKING') {
        try {
          setIsLoading(true)
          let paragraph = ''
          currentQuestion.data.timeline.forEach((item: any) => {
            paragraph += `${item.character_name}: ${item.transcript} \n `
          })
          const params = {
            question: currentQuestion.data.question.question,
            user_answer: dataReply,
            paragraph,
          }
          const res = (await reviseRequest.checkUserAnswer(params)) as any
          if (res.status === 200) {
            const newMessage = {
              type: 'user',
              msg: dataReply,
            }
            const botMessage = [
              {
                type: 'bot',
                msg: res.data.data?.is_correct
                  ? 'Bạn trả lời hoàn toàn chính xác 🥳'
                  : 'Không sao cả, mỗi lần sai là một bước tiến tới thành công 🌟',
              },
              {
                type: 'bot',
                msg: 'Bấm TIẾP TỤC để làm bài tiếp theo nha!',
              },
            ]
            setDataMessages((pre: any) => [...pre, newMessage, ...botMessage])
            setIsResult(res.data.data?.is_correct)
            setIsShowReplyBox(false)
          }
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
        }
        return
      }

      const newMessage = {
        type: 'user',
        msg: dataReply,
      }
      const botMessage = [
        {
          type: 'bot',
          msg: isResult
            ? 'Bạn trả lời hoàn toàn chính xác 🥳'
            : 'Không sao cả, mỗi lần sai là một bước tiến tới thành công 🌟',
        },
        {
          type: 'bot',
          msg: 'Bấm TIẾP TỤC để làm bài tiếp theo nha!',
        },
      ]
      if (isResult) {
        handlePlayAudio(rightAudio)
      } else {
        handlePlayAudio(wrongAudio)
      }
      setIsResult(isResult)
      setIsShowReplyBox(false)
      setDataMessages((pre: any) => [...pre, newMessage, ...botMessage])
    } else {
      if (
        currentQuestionIndex ===
          dataQuestions.questions[currentLevelIndex].length - 1 &&
        currentLevelIndex < dataQuestions.questions.length - 1
      ) {
        setCurrentLevelIndex(currentLevelIndex + 1)
        setCurrentQuestionIndex(0)
        setIsShowReplyBox(true)
      } else {
        setCurrentQuestionIndex(currentQuestionIndex + 1)
        setIsShowReplyBox(true)
      }
      if (
        currentLevelIndex === dataQuestions.questions.length - 1 &&
        currentQuestionIndex ===
          dataQuestions.questions[currentLevelIndex].length - 1
      ) {
        console.log('Hoàn thành')
      }
      setDataReply(null)
      dispatch(updateIsDisableReply(true))
      dispatch(updateIsOpenSubTitle(false))
    }
  }

  const handleResize = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto'
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`
    }
  }

  return (
    <Box className="container-xl" mt={'60px'} pb={'40px'}>
      <Flex>
        <Flex
          w={'100%'}
          minH={'550px'}
          gap={'12px'}
          flexDirection={{base: 'column', lg: 'row'}}>
          {/* Audio */}
          <Flex
            w={{base: '100%', lg: '40%'}}
            bg={'white'}
            borderRadius={'16px'}
            overflow={'hidden'}
            flexDirection={'column'}>
            <Box h={'380px'}>
              <VideoCustom
                isIntro={false}
                px="24px"
                py="16px"
                fontSize="16px"
              />
            </Box>
            <Box mt={'32px'} pb={'20px'}>
              <SubTitle />
            </Box>
          </Flex>

          {/* Hội thoại trả lời câu hỏi */}
          <Flex flex={1} bg={'white'} borderRadius={'16px'}>
            <Flex p={'24px'} flex={1} flexDirection={'column'}>
              <Text
                fontSize={'16px'}
                color={'#8C8C8C'}
                textTransform={'uppercase'}>
                {getDescriptionQuestion()}
              </Text>
              <Flex mt={'24px'} flexDirection={'column'} flex={1}>
                {/* Lấy Message của bot hoặc user */}
                {dataMessages.map((item: any, index: any) => {
                  return item.type == 'bot' ? (
                    <MessageBot key={index} data={item} />
                  ) : (
                    <MessageReply key={index} data={item} isResult={isResult} />
                  )
                })}
                {isShowReplyBox && getReplyBox()}
              </Flex>
              <Flex justifyContent={'center'} mb={'24px'}>
                {currentQuestion.type === 'LV3_LISTEN_AND_ANSWER_BY_SPEAKING' &&
                isShowInput ? (
                  <Flex
                    gap={{base: '12px', md: '20px'}}
                    alignItems={'center'}
                    alignSelf={'center'}
                    w={{base: '100%', md: 'auto'}}>
                    <Center
                      flexShrink={0}
                      w={{base: '40px', md: '50px'}}
                      h={{base: '40px', md: '50px'}}
                      borderRadius={'50%'}
                      shadow={'md'}>
                      <Icon
                        as={RotateLeft}
                        w={{base: '24px', md: '24px'}}
                        h={{base: '24px', md: '24px'}}
                        cursor={'pointer'}
                        onClick={() => {
                          setIsShowInput(false)
                          setDataReply('')
                        }}></Icon>
                    </Center>
                    <Flex
                      flexDirection={'row'}
                      alignItems={'center'}
                      gap={{base: '12px', md: '16px'}}
                      bg={CommonColors.shadow1}
                      borderRadius={'16px'}
                      p={{base: '12px', md: '16px'}}
                      minH={'52px'}
                      w={{base: '100%', md: '500px'}}>
                      <Textarea
                        borderWidth={0}
                        outline={'none'}
                        p={'0px'}
                        textColor={CommonColors.white}
                        value={dataReply}
                        rows={1}
                        resize="vertical"
                        ref={textAreaRef}
                        fontSize={'16px'}
                        _focus={{
                          outline: 'none',
                          boxShadow: 'none',
                        }}
                        onKeyDown={event => {
                          if (event.keyCode === 13 && dataReply?.trim()) {
                            // handleSendText()
                            // setDataReply('')
                            setIsShowInput(false)
                          }
                        }}
                        onInput={handleResize}
                        onChange={event => setDataReply(event.target.value)}
                      />
                      <Image
                        w={{base: '16px', md: '24px'}}
                        h={{base: '16px', md: '24px'}}
                        cursor={dataReply?.trim() ? 'pointer' : 'not-allowed'}
                        opacity={dataReply?.trim() ? 1 : 0.5}
                        src={IconSend}
                        onClick={() => {
                          if (dataReply?.trim()) {
                            setIsShowInput(false)
                          }
                        }}
                      />
                    </Flex>
                  </Flex>
                ) : (
                  dataReply && (
                    <Button
                      isDisabled={isDisableReply || !dataReply || isLoading}
                      w={'300px'}
                      borderRadius={'16px'}
                      bg={'#1890FF'}
                      color={'white'}
                      _hover={{
                        bg: '#0069c9',
                      }}
                      onClick={handleTestReply}>
                      {isShowReplyBox
                        ? isLoading
                          ? 'Loading...'
                          : 'Kiểm tra'
                        : 'Tiếp tục'}
                    </Button>
                  )
                )}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Exercise3
